/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValueTuple_List_1_ImportTransferAllocateParseDto } from '../models/ValueTuple_List_1_ImportTransferAllocateParseDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_UpdateDesiredTotalSharesDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_UpdateDesiredTotalSharesDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAllocateLegacyService {

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocateLegacyDesiredTotalShares(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_UpdateDesiredTotalSharesDto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate-legacy/desired-total-shares',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fileExtension 
     * @param forDrs 
     * @param requestBody 
     * @returns ValueTuple_List_1_ImportTransferAllocateParseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateLegacyParseTransferAndAllocate(
fileExtension?: string,
forDrs?: boolean,
requestBody?: Blob,
): CancelablePromise<ValueTuple_List_1_ImportTransferAllocateParseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate-legacy/parse-transfer-and-allocate',
            query: {
                'fileExtension': fileExtension,
                'forDrs': forDrs,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
